import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './styles.scss';

class Banner extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { topic: { image, imagePos, bgColor, opacity, pageTitle }, showHomeButton } = this.props;

    return (
      <div className="banner-wrapper">
        {
          showHomeButton &&
          <Link className="banner-home-button" to="/">
            <svg viewBox="0 0 32 31.9" id="gel-icon-home" width="100%" height="100%"><path d="M16 5.4l-12 12v14.5h9V22h6v9.9h9V17.4l-12-12"></path><path d="M28 12V4h-4v4l-6.6-6.6L16 0l-1.4 1.4L0 16v2.8l16-16 16 16V16"></path></svg>
            <span>Home</span>
          </Link>
        }
        <div className="banner-bg-image" style={{ backgroundImage: `url(${image.replace('480xn','720xn')})`, backgroundPosition: imagePos }}></div>
        <div className="banner-overlay" style={{ backgroundColor: bgColor, opacity: opacity ? opacity : '0.8' }}></div>
        <div className="banner-title">{pageTitle}</div>
      </div>
    );
  }
}

export default Banner;

Banner.defaultProps = {
  showHomeButton: true
}